'use client';

import { Box, Container, Typography, Stack, alpha, Link as MuiLink } from '@mui/material';
import Link from 'next/link';

import { brandingConfig } from '../config/branding';

const quickLinks = [
  { label: 'About', href: '/about' },
  { label: 'Support', href: '/support' },
  { label: 'Terms', href: '/terms' },
  { label: 'Privacy', href: '/privacy' },
];

export default function DesktopFooter() {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: '#1e293b',
        color: '#fff',
        py: 2,
        mt: 'auto',
      }}
    >
      <Container maxWidth="xl">
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          justifyContent="space-between"
          alignItems="center"
          spacing={1.5}
        >
          {/* Left - Brand */}
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography sx={{ fontWeight: 700, fontSize: '0.95rem', color: '#fff' }}>
              {brandingConfig.brandName}
            </Typography>
            <Typography sx={{ color: alpha('#fff', 0.5), fontSize: '0.85rem' }}>
              © {currentYear} {brandingConfig.legal.companyName}
            </Typography>
          </Stack>

          {/* Center - Quick Links */}
          <Stack direction="row" spacing={2.5}>
            {quickLinks.map((link, index) => (
              <Link key={index} href={link.href} passHref legacyBehavior>
                <MuiLink
                  sx={{
                    color: alpha('#fff', 0.6),
                    textDecoration: 'none',
                    fontSize: '0.8rem',
                    fontWeight: 500,
                    '&:hover': { color: '#fff' },
                    transition: 'color 0.2s',
                  }}
                >
                  {link.label}
                </MuiLink>
              </Link>
            ))}
          </Stack>

          {/* Right - Contact */}
          <Typography sx={{ color: alpha('#fff', 0.5), fontSize: '0.8rem' }}>
            {brandingConfig.contact.supportEmail}
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
}
